<template>
  <v-card>
    <vue-card-title
      :title="'Activity Logs'"
      :subtitle="
        'Refer to the following information for the activity logs filtering organization.'
      "
      :icon="$getIcon('mdiCommentAlertOutline')"
      ><template slot="actions">
        <v-btn disabled icon @click="filter.show = !filter.show">
          <v-icon small v-text="$getIcon('mdiFilterVariant')"></v-icon>
        </v-btn>
      </template>
    </vue-card-title>
    <v-divider></v-divider>
    <v-slide-y-transition>
      <v-row v-show="filter.show" class="mx-3 py-0">
        <v-col>
          <v-text-field
            v-model="search"
            label="Search"
            :append-icon="$getIcon('mdiMagnify')"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col></v-col>
      </v-row>
    </v-slide-y-transition>
    <v-divider v-if="filter.show"></v-divider>
    <v-tabs show-arrows v-model="filter.activeStatus" slider-color="blue">
      <v-tab
        v-for="tab in tabs"
        :key="tab.tabName"
        ripple
        :disabled="tab.disable"
        @click="setStatus(tab.tabName)"
      >
        <span class="pr-2 text-capitalize">{{ tab.tabName }}</span>
        <v-chip
          v-if="tab.tabName !== 'Process'"
          :color="tab.color"
          small
          class="white--text"
        >
          {{ pagination.totalItems }}
        </v-chip>
      </v-tab>
    </v-tabs>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="fetchedResults"
        :loading="loading"
        :sort-desc.sync="pagination.descending"
        :sort-by.sync="pagination.sortBy"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.rowsPerPage"
        :footer-props="footerProps"
        :server-items-length="pagination.totalItems"
        must-sort
        class="elevation-1"
        mobile-breakpoint="0"
      >
        <template v-slot:item="props">
          <tr>
            <td>
              <div
                v-if="
                  props.item.sub_stage_logs.length &&
                    props.item.sub_stage_logs[0].sales_achievements.length
                "
                class="font-weight-bold"
              >
                {{
                  props.item.sub_stage_logs[0].sales_achievements &&
                    props.item.sub_stage_logs[0].sales_achievements[0].service
                      .name
                }}
              </div>
              <div v-else>-</div>
              <div class="text--secondary">
                {{ props.item.sub_stage_logs.length ? "Service" : "General" }}
              </div>
            </td>
            <td>
              <div
                v-if="
                  props.item.sub_stage_logs.length &&
                    props.item.sub_stage_logs[0].sales_achievements.length
                "
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      {{
                        getJobPositions(
                          props.item.sub_stage_logs[0].sales_achievements[0],
                          true
                        )
                      }}
                    </div>
                  </template>
                  <span>
                    {{
                      getJobPositions(
                        props.item.sub_stage_logs[0].sales_achievements[0]
                      )
                    }}
                  </span>
                </v-tooltip>
              </div>
              <div v-else>-</div>
            </td>
            <td class="text-center">
              <div>
                {{ $dayjs(props.item.created_at).format("DD-MM-YYYY") }}
              </div>
              <div class="caption text--secondary">
                {{ $dayjs(props.item.created_at).format("hh:mmA") }}
              </div>
            </td>
            <td>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-hover>
                    <v-icon
                      v-if="
                        props.item.communicationlog &&
                          props.item.communicationlog.follow_up_datetime
                      "
                      v-on="on"
                      size="20"
                      v-text="$getIcon('mdiFlashRedEye')"
                      class="mr-1"
                      :color="colorMapper[props.item.communicationlog.priority]"
                    ></v-icon>
                    <v-icon
                      v-else
                      v-on="on"
                      size="20"
                      v-text="$getIcon('mdiFlash')"
                      class="mr-1"
                      :color="colorMapper[props.item.communicationlog.priority]"
                    ></v-icon>
                  </v-hover>
                </template>
                <span>
                  <div class="text-left">
                    <strong>Priority:</strong>
                    {{
                      (props.item.communicationlog &&
                        props.item.communicationlog.priority) ||
                        "None"
                    }}
                  </div>
                  <div
                    v-if="
                      props.item.communicationlog &&
                        props.item.communicationlog.follow_up_datetime
                    "
                  >
                    <strong>FollowUp:</strong>
                    {{
                      props.item.communicationlog &&
                      props.item.communicationlog.follow_up_datetime
                        ? $dayjs(
                            props.item.communicationlog.follow_up_datetime
                          ).format("DD-MM-YYYY")
                        : ""
                    }}
                    {{
                      props.item.communicationlog &&
                      props.item.communicationlog.follow_up_datetime
                        ? $dayjs(
                            props.item.communicationlog.follow_up_datetime
                          ).format("hh:mm A")
                        : ""
                    }}
                  </div>
                </span>
              </v-tooltip>
            </td>
            <td>
              <v-row align="center" no-gutters>
                <v-col class="text-left ml-2 font-weight-bold">
                  <div>
                    {{
                      $getProp(
                        props.item,
                        "communicationlog.contacted_with.name"
                      ) || "Fix null"
                    }}
                  </div>
                  <div class="caption grey--text">
                    {{
                      $getProp(
                        props.item,
                        "communicationlog.contacted_with.designation.name"
                      )
                    }}
                  </div>
                </v-col>
              </v-row>
            </td>
            <td>
              <span
                ><v-icon v-text="getTimeLineIcon(props.item)"></v-icon
              ></span>
              <span
                ><v-icon
                  small
                  v-text="
                    getIconForLog(
                      $getProp(props.item, 'communicationlog.medium_direction')
                    )
                  "
                ></v-icon
              ></span>
            </td>
            <td align="center">
              <v-menu open-on-hover offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar v-bind="attrs" v-on="on" :size="35">
                    <v-img
                      :src="
                        $getProp(props.item, 'logged_by.picture') ||
                          require(`@/static/images/info/user-default.png`)
                      "
                      alt="CRE avatar"
                    ></v-img>
                  </v-avatar>
                </template>

                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      <v-row align="center" no-gutters>
                        <v-avatar :size="35">
                          <v-img
                            :src="
                              $getProp(props.item, 'logged_by.picture') ||
                                require(`@/static/images/info/user-default.png`)
                            "
                            alt="CRE avatar"
                          ></v-img>
                        </v-avatar>
                        <v-col class="text-left ml-2 font-weight-bold caption">
                          <div>
                            {{
                              $getProp(props.item, "logged_by.full_name") ||
                                "Fix null"
                            }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
            <td>
              {{
                (props.item.sub_stage_logs.length &&
                  props.item.sub_stage_logs[0].sales_stage) ||
                  "-"
              }}
            </td>
            <td>
              <v-btn icon class="">
                <v-icon
                  v-text="$getIcon('mdiEye')"
                  color="blue"
                  @click="(logInfoKey += 1), (logInfo = props.item)"
                ></v-icon>
              </v-btn>
              <v-btn
                v-if="
                  props.item.sub_stage_logs.length &&
                    props.item.sub_stage_logs[0].sales_achievements.length
                "
                icon
                class="px-3"
              >
                <v-icon
                  v-text="$getIcon('mdiLinkVariant')"
                  color="blue"
                  @click="
                    $emit('linkToChain', {
                      ...$getProp(
                        props.item,
                        'sub_stage_logs.0.sales_achievements.0'
                      ),
                      ...{
                        contactPerson: $getProp(
                          props.item,
                          'communicationlog.contacted_with'
                        )
                      }
                    })
                  "
                ></v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <template slot="no-data">
          <vue-data-table-no-data :loading="loading"></vue-data-table-no-data>
        </template>
      </v-data-table>
    </v-card-text>
    <log-detail
      :key="logInfoKey"
      v-if="logInfo"
      :logInfo.sync="logInfo"
    ></log-detail>
  </v-card>
</template>
<script>
import DataTableMixin from "@/mixins/dataTableMixin";
import mediumIcons from "@/utils/mediumIcons.js";

export default {
  mixins: [DataTableMixin],
  mediumIcons,
  components: {
    LogDetail: () => import("./LogDetail")
  },
  data() {
    return {
      tabs: [
        { tabName: "Communication", value: "", color: "info" },
        {
          tabName: "Process",
          value: "",
          disable: true,
          color: "green"
        },
        { tabName: "All", value: "", color: "cyan" }
      ],
      headers: [
        {
          text: "Product Name/Log Type",
          align: "left",
          sortable: false,
          class: "grey lighten-4"
        },
        {
          text: "Job Positions",
          align: "left",
          sortable: false,
          class: "grey lighten-4"
        },
        {
          text: "Date/Time",
          align: "left",
          sortable: false,
          class: "grey lighten-4"
        },
        {
          text: "Priority",
          align: "left",
          sortable: false,
          class: "grey lighten-4"
        },
        {
          text: "Contact Person",
          align: "left",
          sortable: false,
          class: "grey lighten-4"
        },
        {
          text: "Medium",
          align: "left",
          sortable: false,
          class: "grey lighten-4"
        },
        {
          text: "User",
          align: "",
          sortable: false,
          class: "grey lighten-4"
        },
        {
          text: "Stage",
          align: "left",
          sortable: false,
          class: "grey lighten-4"
        },
        {
          text: "Actions",
          align: "left",
          sortable: false,
          class: "grey lighten-4"
        }
      ],
      colorMapper: {
        Critical: "red",
        Important: "orange",
        Normal: "green",
        Low: "blue"
      },
      rowsPerPageItems: [7, 10, 20, 30, 40, 50],
      loading: false,
      searchLabel: "Search for logs",
      filter: {
        dateFilter: {},
        activeStatus: 0,
        show: false
      },
      search: "",
      status: "",
      selectedTab: "",
      DataTableFilter() {
        return {
          status: this.selectedTab || "",
          search: this.search
        };
      },
      logInfo: null,
      logInfoKey: 1
    };
  },
  props: {
    clientSlug: {
      type: String,
      default: undefined
    }
  },
  computed: {
    fetchAPI() {
      let api = "";
      if (this.clientSlug) {
        api = `/api/v1/crm/logs/?organization=${this.$store.state.shell.currentOrganizationId}&client__slug=${this.clientSlug}`;
      } else {
        api = `/api/v1/crm/logs/?organization=${this.$store.state.shell.currentOrganizationId}`;
      }
      return `${api}&${this.urlParams}`;
    }
  },
  methods: {
    getJobPositions(value, isTruncated = false) {
      const jobPositionsArray = value?.data?.job_positions || ["N/A"];
      return isTruncated
        ? this.truncate(jobPositionsArray.join(", "), 15)
        : jobPositionsArray.join(", ");
    },
    truncate(text, length, suffix) {
      if (!text) return "";
      let truncatedText = "";
      suffix = suffix || "...";
      if (text.length > length) {
        truncatedText = text.substring(0, length) + suffix;
      } else {
        truncatedText = text.substring(0, length);
      }
      return truncatedText;
    },
    async fetchDataTable() {
      this.loading = true;
      await this.$axios
        .$get(this.fetchAPI, { params: this.fullParams })
        .then(response => {
          this.loadDataTable(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getIconForLog(direction) {
      if (direction === "Inbound") {
        return this.$getIcon("mdiArrowLeft");
      } else {
        return this.$getIcon("mdiArrowRight");
      }
    },
    setStatus(status) {
      this.selectedTab = status === "All" ? "" : status;
      this.pagination.page = 1;
    },
    getTimeLineIcon(log) {
      if (log.communicationlog) {
        return this.$options.mediumIcons[
          this.$getProp(log, "communicationlog.medium.icon")
        ];
      } else if (log.processlog) {
        return this.$getIcon("mdiClipboardText");
      }
      return this.$getIcon("mdiClipboardText");
    },
    humanizeDate(timeStamp) {
      return this.$dayjs(timeStamp).fromNow();
    }
  }
};
</script>
